// #region -- importaciones y estilos del modal
import React, { useEffect, useState, Fragment } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Button from 'components/CustomButtons/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import { Avatar, Checkbox, TextField } from '@material-ui/core';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardHeader from 'components/Card/CardHeader.js';
import CardIcon from 'components/Card/CardIcon.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import MapIcon from '@material-ui/icons/Map';
import moment from 'moment';
import Tooltip from '@material-ui/core/Tooltip';

//primera tabla
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';

//iportacion para el listado
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import {
  GpsFixed,
  LocationOff,
  Map,
  PersonPinCircle,
  RemoveShoppingCartRounded,
  Room,
  ShoppingCartRounded,
  Visibility,
} from '@material-ui/icons';

//modal imports mapa
import {
  Marker,
  InfoWindow,
  Polyline,
  Polygon,
} from '@react-google-maps/api';

//servicios
import { WithApp } from 'contexts/appContext';
import { wsFindBy } from 'services/WService';
import ModalMapRouteEdit from 'components/Tvendo/Sale/DataMaster/Route/Maps/ModalMapRouteEdit';
import wkt from 'wkt';
import { currency, nPercent } from 'hooks/Pipe';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import {
  defDataGeneral,
  defDataGps,
  defShowMarker,
  defDataQuota,
  optionsPolyline,
  defMapCenter,
} from './defaults';
import { useLocation, useNavigate } from 'react-router-dom';
import { wsUpdate } from 'services/WService';
import GoogleMapCustom from 'components/Tvendo/Common/GoogleMapCustom';

const useStyles = makeStyles((theme) => ({
  table: {
    minWidth: 650,
    '& td': { fontWeight: 'bold' },
  },
  appBar: {
    position: 'relative',
    backgroundColor: '#8e24aa',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
    fontSize: window.screen.width < 600 ? '14px' : '1.25rem',
  },
  grid: {
    height: '100%',
    marginTop: '20px',
    marginButtom: '20px',
  },
  gridButton: {
    display: 'flex',
    alignItems: 'flex-end',
    '& button': {
      width: window.screen.width < 600 ? '100%' : 'auto',
    },
  },
  card: {
    marginTop: '0',
    maxHeight: '100%',
  },
  avatar: {
    width: '16px',
    height: '24px',
  },
  legend: {
    display: 'flex',
    justifyContent: 'space-evenly',
    marginTop: '8px',
  },
  contLegend: {
    display: 'flex',
    fontWeight: 'bold',
    '& img': {
      height: '100%',
    },
    '& span': {
      marginLeft: '5px',
      color: 'black',
    },
  },
  listRoutes: {
    width: '100%',
    overflowY: 'auto',
    maxHeight: '96px',
    '& span': {
      fontWeight: '500',
    },
  },
  addressData: {
    display: 'flex',
    right: 0,
    position: 'absolute',
    '& span': {
      display: 'flex',
      alignItems: 'center',
      marginLeft: '15px',
    },
  },
  listHistory: {
    width: '100%',
    overflowY: 'auto',
    maxHeight: '456px',
    '& span': {
      fontWeight: '500',
    },
  },
  listItemData: {
    minWidth: '500px',
  },
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
    fontWeight: 'bold',
  },
  divStyle: {
    padding: '4px',
    listStyle: 'none',
    background: '#c8f7ec',
    borderRadius: '5px',
    '& span': {
      fontSize: '15px',
      fontWeight: 500,
    },
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// #endregion

export default WithApp(function ModalGps(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const classes = useStyles();
  const handleClose = () => {
    navigate(`${location.pathname}`, { replace: true });
    setOpen(false);
    setDate(null);
    setDefaults();
    setQuotaMark({});
    setQuotaSeller({});
    setPathPolyline([]);
    setMapCenter(defMapCenter);
    setDataPoint({ _state: false });
    setDataOrder({ _state: false });
    setDataNotOrder({ _state: false });
    setPointSeleted(null);
  };

  function setDefaults() {}

  const { open, setOpen, nameList, dataList, setDataList, showNotify, dateFilter } = props;

  //data del mapa
  const [mapCenter, setMapCenter] = useState(defMapCenter);
  const [errorMessage, setErrorMessage] = useState('');

  //data del modal que viene de fuera
  const [showModaRouteEdit, setShowModaRouteEdit] = useState(false); //Abrir modal
  const [routeId, setRouteId] = useState(null);
  const [maxDistance, setMaxDistance] = useState(15);

  //obtener la info para pintar en el mapa
  const [date, setDate] = useState(dateFilter);

  //data del polyline
  const [pathPolyline, setPathPolyline] = useState([]);

  const [dataPoint, setDataPoint] = useState({}); //puntos para el mapa
  const [dataOrder, setDataOrder] = useState({}); //data orden del marker
  const [customerVisited, setCustomerVisited] = useState(0);
  const [dataNotOrder, setDataNotOrder] = useState({}); //data orden del marker
  const [pointSelected, setPointSeleted] = useState(null); // punto seleccionado

  const [dataGeneral, setDataGeneral] = useState(defDataGeneral);
  const [dataGps, setDataGps] = useState(defDataGps);
  const [showMarker, setShowMarker] = useState(defShowMarker);
  const [showAddresses, setShowAddresses] = useState([]);
  const [dataQuota, setDataQuota] = useState(defDataQuota);

  const [quotaMark, setQuotaMark] = useState({});
  const [addresses, setAddresses] = useState([]);
  const [quotaSeller, setQuotaSeller] = useState({});
  const [quotaData, setQuotaData] = useState({});
  const [editingMarker, setEditingMarker] = useState();

  async function updateAddressMarker() {

    let route = dataGeneral.routes.find(
      (route) => parseInt(route.id) === parseInt(editingMarker.order.base_route_id),
    );
    if(route === undefined){
      return showNotify('Error: No se pudo encontrar ruta del pedido', 'danger');
    }

    let res = await wsUpdate('base/address', editingMarker.order.base_address_id, {
      latitude: editingMarker.lat,
      longitude: editingMarker.lng,
      base_layer_id: route.base_layer_id,
    });

    if(res.success){
      showNotify(res.message);
      setDataGeneral(dataGeneral => {
        let newData = { ...dataGeneral };
        let newOrders = [...dataGeneral.orders];
        let index = newOrders.findIndex(order => order.id === editingMarker.order.id);
        newOrders[index].address.latitude = editingMarker.lat;
        newOrders[index].address.longitude = editingMarker.lng;
        newData.orders = newOrders;
        return newData;
      })
      setEditingMarker(undefined);
    }else{
      showNotify(res.message, 'error');
    }
  }

  //listado de uigeos
  async function getUbigeos(date) {
    const search = { base_seller_id: dataList.base_seller_id, date: date };

    setErrorMessage('');
    setPathPolyline([]);
    setDataGps(defDataGps);
    setDataGeneral(defDataGeneral);
    setDataQuota(defDataQuota);
    setAddresses([]);
    if (Object.keys(search).length > 0) {
      if (nameList === 'seller') {
        getQuotaSeller(search);
      } else if (nameList === 'mark') {
        getQuotaMark(search);
      }
      let response = await wsFindBy('ordm/gps', search);
      if (response.success) {
        setMaxDistance(parseFloat(response.no_orders_max_distance));
        const routes = parsePathPoligon(response.data.routes);
        setCustomerVisited(response.data.customer_visited);
        setAddresses(response.data.addresses);
        //centrar el mapa en el primer marcador
        if (response.data.gps.length > 0) {
          // gps válidos
          const gpsValid = response.data.gps.filter((g) => g.latitude !== '0.0');
          // gps que estan con 0
          const sinGps = response.data.gps.filter((item) => item.latitude === '0.0').length;

          //data para construir las lineas
          let pathPolyline = gpsValid.map((latLng) => {
            return {
              lat: parseFloat(latLng.latitude),
              lng: parseFloat(latLng.longitude),
            };
          });
          setPathPolyline(pathPolyline);

          let initPoint = null;
          let endPoint = null;
          if (gpsValid.length > 1) {
            //punto donde inicia el marcador
            initPoint = {
              lat: parseFloat(gpsValid[0].latitude),
              lng: parseFloat(gpsValid[0].longitude),
              point: gpsValid[0],
            };

            //punto donde termina el marcador
            const totalGps = gpsValid.length - 1;
            endPoint = {
              lat: parseFloat(gpsValid[totalGps].latitude),
              lng: parseFloat(gpsValid[totalGps].longitude),
              point: gpsValid[totalGps],
            };
            setMapCenter(initPoint); //centro del mapa
          }

          setDataGps({
            gps: gpsValid,
            notGps: sinGps,
            polyline: pathPolyline,
            initPoint: initPoint,
            endPoint: endPoint,
          }); //setear data de los gps

          if (gpsValid.length > 0) {
          } else {
            if (routes?.length > 0 && routes[0]?.geometry !== null) {
              setMapCenter(routes[0].geometry[0]); //centrar del mapa
            }

            showNotify('No hay puntos disponibles', 'info');
          }
        } else if (response.data.gps.length === 0) {
          //Si no hay marcadores, centrar en la primera ruta
          if (routes?.length > 0 && routes[0]?.geometry !== null) {
            setMapCenter(routes[0].geometry[0]); //centrar del mapa
          }
        }

        if (nameList === 'seller') {
          const dataOrders =
            response.data.orders.sort((a, b) => (a.created_at > b.created_at ? 1 : -1)) || [];
          const ordersConcat = dataOrders.concat(response.data.no_orders);
          const formatDataAllOrders = ordersConcat
            .map((item) => {
              return {
                ...item,
                created_at: moment(item.created_at).format('HH:mm:ss'),
              };
            })
            .sort((a, b) => (a.created_at > b.created_at ? 1 : -1));

          setDataGeneral({
            orders: dataOrders,
            notOrders: response.data.no_orders,
            routes: routes,
            allOrders: formatDataAllOrders,
          });

          //suma de los montos procesados
          let totalAmountProcess = dataOrders
            .filter((item) => item.state === 'P')
            .reduce((a, { total_amount }) => a + total_amount, 0);

          //suma de los montos pendientes
          let totalAmountPending = dataOrders
            .filter((item) => item.state !== 'P' && item.state !== 'A')
            .reduce((a, { total_amount }) => a + total_amount, 0);

          //total cantidad de clientes de las rutas
          let totalCustomers = 0;
          for (let i of routes) {
            totalCustomers += parseInt(i.addressData.total_addresses);
          }

          setDataQuota({
            processAmt: totalAmountProcess,
            pendingAmt: totalAmountPending,
            customers: totalCustomers,
          });
        } else if (nameList === 'mark') {
          // TODO hacer mas funciones cuando tenga data de marcas
          const dataOrders =
            response.data.orders.sort((a, b) => (a.created_at > b.created_at ? 1 : -1)) || [];
          const ordersConcat = dataOrders.concat(response.data.no_orders);
          const formatDataAllOrders = ordersConcat
            .map((item) => {
              return {
                ...item,
                created_at: moment(item.created_at).format('HH:mm:ss'),
              };
            })
            .sort((a, b) => (a.created_at > b.created_at ? 1 : -1));

          setDataGeneral({
            orders: dataOrders,
            notOrders: response.data.no_orders,
            routes: routes,
            allOrders: formatDataAllOrders,
          });

          //suma de los montos procesados
          let totalAmountProcess = dataOrders
          .filter((item) => item.state === 'P')
          .reduce((a, { total_amount }) => a + total_amount, 0);

          //suma de los montos pendientes
          let totalAmountPending = dataOrders
            .filter((item) => item.state !== 'P' && item.state !== 'A')
            .reduce((a, { total_amount }) => a + total_amount, 0);

          //total cantidad de clientes de las rutas
          let totalCustomers = 0;
          for (let i of routes) {
            totalCustomers += parseInt(i.addressData.total_addresses);
          }

          setDataQuota({
            processAmt: totalAmountProcess,
            pendingAmt: totalAmountPending,
            customers: totalCustomers,
          });
        }
      } else {
        setErrorMessage(response.message);
        showNotify(response.message, 'error');
      }
    }
  }

  const parsePathPoligon = (data) => {
    data.map((obj) => {
      if (obj.geometry != null) {
        obj.geometry = wkt.parse(obj.geometry).coordinates[0].map((point) => {
          return {
            lng: point[0],
            lat: point[1],
          };
        });
      }
      return obj;
    });
    return data;
  };

  async function getQuotaMark(search) {
    if (dataList.logi_mark_id === null) {
      return showNotify('Este registro no tiene cuota', 'info');
    }
    let response = await wsFindBy('base/quota/mark/' + dataList.logi_mark_id, search);
    if (response.success) {
      let orders = response.data.orders.map((order) => ({
        ...order,
        address: {
          base_address_id: order.base_address_id,
          latitude: order.latitude,
          longitude: order.longitude,
        },
      }));
      setDataGeneral(dataGeneral => ({ ...dataGeneral, orders }));
      setQuotaMark(response.data.quota);
    }
  }

  async function getQuotaSeller(search) {
    setQuotaData({});
    let response = await wsFindBy('base/quota/seller/' + dataList.base_seller_id, search);
    if (response.success) {
      setQuotaSeller(response.data);
      setQuotaData(response.data.quotaData);
      let seller = response.data.seller;
      setDataList((dataList) => {
        return { ...dataList, total_customers: seller.total_customers };
      });
    };
  }

  const stateOrder = (state) => {
    switch (state) {
      case 'X':
        state = 'Pendiente';
        break;
      case 'S':
        state = 'Sin Stock';
        break;
      case 'A':
        state = 'Anulado';
        break;
      case 'E':
        state = 'Editado';
        break;
      case 'P':
        state = 'Procesado';
        break;
      case 'R':
        state = 'Retenido';
        break;
      default:
        state = '-';
        break;
    }
    return state;
  };

  const filterGps = (data, everyone = false) => {
    //sin everyone es falso, muestra los gps del usuario principal
    //sin everyone es true, muestra los gps de todos (ejem: intruso)
    return !everyone ? [...data].filter((g) => g.work_day_uuid) : data;
  };

  const handleShowMarker = (e, value) => {
    setShowMarker({ ...showMarker, [value]: !showMarker[value] });
  };

  useEffect(() => {
    if (open) {
      getUbigeos(dateFilter);
      setDate(dateFilter);
    }
    return () => {
      setDataGeneral(defDataGeneral);
      setDataGps(defDataGps);
      setShowMarker(defShowMarker);
      setDataQuota(defDataQuota);
    };
  }, [open]);

  return (
    <Fragment>
      <ModalMapRouteEdit
        showModal={showModaRouteEdit}
        setShowModal={setShowModaRouteEdit}
        routeId={routeId}
        setRouteId={setRouteId}
        showNotify={showNotify}
      />

      <Dialog fullScreen open={open} onClose={handleClose} TransitionComponent={Transition}>
        {open ? (
          <GridContainer style={{ width: 'calc(100% + 0px)', margin: '0' }}>
            <AppBar className={classes.appBar}>
              <Toolbar>
                <IconButton edge="start" color="inherit" onClick={handleClose} aria-label="close">
                  <CloseIcon />
                </IconButton>
                <Typography variant="h6" className={classes.title}>
                  {dataList.SlpName}
                  {nameList === 'mark' ? ` - (${dataList.logi_mark_description})` : ''}
                </Typography>
              </Toolbar>
            </AppBar>
            <GridItem xs={12} sm={12} className={classes.grid}>
              <GridContainer>
                <GridItem xs={12} sm={12} style={{ marginBottom: '20px' }}>
                  <TableContainer component={Paper}>
                    {nameList === 'seller' ? (
                      <QuotaSellerData
                        classes={classes}
                        dataList={dataList}
                        quotaData={quotaData}
                        customerVisited={customerVisited}
                        {...dataQuota}
                        {...dataGeneral}
                      />
                    ) : undefined}

                    {nameList === 'mark' ? (
                      <QuotaMarkData classes={classes} quotaMark={quotaMark} />
                    ) : undefined}
                  </TableContainer>
                </GridItem>
              </GridContainer>

              <GridContainer>
                <GridItem xs={12} md={5} xl={7}>
                  <GridContainer>
                    <GridItem xs={12} sm={8} md={8}>
                      <GridContainer>
                        <GridItem xs={12} sm={7}>
                          <TextField
                            label="Ingrese una fecha"
                            fullWidth
                            type="date"
                            defaultValue={dateFilter || moment().format('YYYY-MM-DD')}
                            onChange={(e) => {
                              setDate(e.target.value);
                              getUbigeos(e.target.value);
                            }}
                            InputLabelProps={{ shrink: true }}
                            inputProps={{ max: moment().format('YYYY-MM-DD') }}
                          />
                        </GridItem>

                        <GridItem xs={12} sm={5}>
                          <span style={{ color: 'red' }}>{errorMessage}</span>
                        </GridItem>
                      </GridContainer>
                    </GridItem>
                    <GridItem
                      xs={12}
                      sm={4}
                      md={4}
                      style={{ display: 'flex', justifyContent: 'flex-end' }}
                    >
                      <ShowOptions
                        showMarker={showMarker}
                        handleShowMarker={handleShowMarker}
                        nameList={nameList}
                        total={{
                          orders: dataGeneral.orders.length,
                          notOrders: dataGeneral.notOrders.length,
                        }}
                      />
                    </GridItem>

                    <GridItem xs={12} sm={12} md={12} className={classes.grid}>
                      <GoogleMapCustom
                        mapContainerStyle={{
                          width: '100%',
                          height: '100%',
                          minHeight: '690px',
                        }}
                        zoom={16}
                        center={mapCenter}
                        onClick={() => {
                          setPointSeleted(null);
                          setDataPoint({ _state: false });
                          setDataOrder({ _state: false });
                          setDataNotOrder({ _state: false });
                        }}
                      >
                        {dataGeneral.routes.map((route, i) => (
                          <Polygon
                            key={i}
                            options={{ fillColor: '#0effe86b' }}
                            paths={route.geometry}
                          />
                        ))}

                        <Polyline path={pathPolyline} options={optionsPolyline} />

                        {/* Marcador punto o marcador infiltrador */}
                        {showMarker.route
                          ? filterGps(dataGps.gps, showMarker.allMarkers).map((point, i) => (
                              <Marker
                                zIndex={100}
                                key={i}
                                position={{
                                  lat: parseFloat(point.latitude),
                                  lng: parseFloat(point.longitude),
                                }}
                                icon={point.work_day_uuid ? '/img/point.png' : '/img/plas.png'}
                                onClick={() => setDataPoint({ ...point, _state: true })}
                              />
                            ))
                          : undefined}

                        {/* Guía / indicador */}
                        {pointSelected !== null ? (
                          <Marker
                            zIndex={10}
                            position={{ lat: pointSelected.lat, lng: pointSelected.lng }}
                            icon="/img/mark.png"
                          />
                        ) : undefined}

                        {/* Inicio recorrido */}
                        {dataGps.initPoint ? (
                          <Marker
                            zIndex={11}
                            position={{ lat: dataGps.initPoint.lat, lng: dataGps.initPoint.lng }}
                            icon="/img/ping.png"
                            onClick={() =>
                              setDataPoint({ ...dataGps.initPoint.point, _state: true })
                            }
                          />
                        ) : undefined}

                        {/* Fin recorrido */}
                        {dataGps.endPoint ? (
                          <Marker
                            zIndex={12}
                            position={{ lat: dataGps.endPoint.lat, lng: dataGps.endPoint.lng }}
                            icon="/img/pingEnd.png"
                            onClick={() =>
                              setDataPoint({ ...dataGps.endPoint.point, _state: true })
                            }
                          />
                        ) : undefined}

                        {showMarker.notOrder
                          ? dataGeneral.notOrders.map((item, i) => {
                              return (
                                <Marker
                                  zIndex={12}
                                  key={i}
                                  position={{
                                    lat: parseFloat(item.latitude),
                                    lng: parseFloat(item.longitude),
                                  }}
                                  icon="/img/notOrder.png"
                                  onClick={() => setDataNotOrder({ ...item, _state: true })}
                                />
                              );
                            })
                          : undefined}

                        {showMarker.notOrder
                          ? dataGeneral.notOrders.map((item, i) => {
                              return (
                                <Marker
                                  zIndex={12}
                                  key={i}
                                  position={{
                                    lat: parseFloat(item.address.latitude),
                                    lng: parseFloat(item.address.longitude),
                                  }}
                                  onClick={() => setDataNotOrder({ ...item, _state: true })}
                                />
                              );
                            })
                          : undefined}

                        {showMarker.order
                          ? dataGeneral.orders.map((item, i) => {
                              return (
                                <Marker
                                  zIndex={13}
                                  key={i}
                                  position={{
                                    lat: parseFloat(item.latitude),
                                    lng: parseFloat(item.longitude),
                                  }}
                                  icon="/img/order.png"
                                  onClick={() => setDataOrder({ ...item, _state: true })}
                                />
                              );
                            })
                          : undefined}

                        {showAddresses &&
                          addresses.map((address, i) => {
                            return (
                              <Marker
                                zIndex={13}
                                key={i}
                                position={{
                                  lat: parseFloat(address.latitude),
                                  lng: parseFloat(address.longitude),
                                }}
                                icon="/img/marcadores/amarillo.png"
                                onClick={() => setDataOrder({ ...address, _state: true })}
                              />
                            );
                          })}

                        {showMarker.order
                          ? dataGeneral.orders.map((item, i) => {
                              if (
                                editingMarker !== undefined &&
                                editingMarker.order.id === item.id
                              ) {
                                return undefined;
                              }
                              return (
                                <Marker
                                  zIndex={13}
                                  key={i}
                                  position={{
                                    lat: parseFloat(item.address.latitude),
                                    lng: parseFloat(item.address.longitude),
                                  }}
                                  onRightClick={() => {
                                    setEditingMarker({
                                      order: item,
                                      lat: parseFloat(item.address.latitude),
                                      lng: parseFloat(item.address.longitude),
                                      originalLat: parseFloat(item.address.latitude),
                                      originalLng: parseFloat(item.address.longitude),
                                    });
                                  }}
                                  onClick={() => setDataOrder({ ...item, _state: true })}
                                />
                              );
                            })
                          : undefined}

                        {editingMarker !== undefined && (
                          <>
                            <Marker
                              position={{
                                lat: editingMarker.originalLat,
                                lng: editingMarker.originalLng,
                              }}
                              icon={'/img/mark.png'}
                              onRightClick={() => {
                                setEditingMarker(undefined);
                              }}
                            />
                            <Marker
                              position={{
                                lat: editingMarker.lat,
                                lng: editingMarker.lng,
                              }}
                              draggable
                              icon={'/img/marker.png'}
                              onRightClick={updateAddressMarker}
                              onDragEnd={(e) => {
                                setEditingMarker((data) => ({
                                  ...data,
                                  lat: e.latLng.lat(),
                                  lng: e.latLng.lng(),
                                }));
                              }}
                            />
                          </>
                        )}

                        {dataPoint._state ? (
                          <InfoWindow
                            position={{
                              lat: parseFloat(dataPoint.latitude),
                              lng: parseFloat(dataPoint.longitude),
                            }}
                            onCloseClick={() => {
                              setDataPoint({ _state: false });
                            }}
                            options={{
                              pixelOffset: {
                                width: 0,
                                height: -25,
                              },
                            }}
                          >
                            <div className={classes.divStyle}>
                              <li>
                                <span>Hora: </span>
                                {moment(dataPoint.created_at).format('H:mm:ss')}
                              </li>
                            </div>
                          </InfoWindow>
                        ) : undefined}

                        {/* Data de la venta */}
                        {showMarker.order && dataOrder._state ? (
                          <InfoWindow
                            position={{
                              lat: parseFloat(dataOrder.latitude),
                              lng: parseFloat(dataOrder.longitude),
                            }}
                            onCloseClick={() => {
                              setDataOrder({ _state: false });
                            }}
                            options={{
                              pixelOffset: {
                                width: 0,
                                height: -25,
                              },
                            }}
                          >
                            <div className={classes.divStyle}>
                              <li>
                                <strong>{dataOrder.CardName}</strong>
                              </li>
                              <li style={{ textAlign: 'center' }}>{dataOrder.CardCode}</li>
                              {dataOrder.total_amount !== undefined && (
                                <li style={{ textAlign: 'center', borderTop: '1px solid #a1a1a1' }}>
                                  <strong>{currency(dataOrder.total_amount)}</strong>
                                </li>
                              )}
                            </div>
                          </InfoWindow>
                        ) : undefined}

                        {showMarker.notOrder && dataNotOrder._state ? (
                          <InfoWindow
                            position={{
                              lat: parseFloat(dataNotOrder.latitude),
                              lng: parseFloat(dataNotOrder.longitude),
                            }}
                            onCloseClick={() => {
                              setDataNotOrder({ _state: false });
                            }}
                            options={{
                              pixelOffset: {
                                width: 0,
                                height: -25,
                              },
                            }}
                          >
                            <div className={classes.divStyle}>
                              <li>{dataNotOrder.CardName}</li>
                              <li>
                                <span>Motivo: </span>
                                {dataNotOrder.reason_description}
                              </li>
                            </div>
                          </InfoWindow>
                        ) : undefined}
                      </GoogleMapCustom>
                    </GridItem>
                    {window.screen.width > 1024 ? (
                      <Legend
                        classes={classes}
                        showAddresses={showAddresses}
                        setShowAddresses={setShowAddresses}
                      />
                    ) : undefined}
                  </GridContainer>
                </GridItem>
                <GridItem
                  xs={12}
                  md={7}
                  xl={5}
                  className={classes.grid}
                  style={{
                    marginTop: window.screen.width > 1024 ? '12px' : '35px',
                  }}
                >
                  <GridContainer>
                    <GridItem xs={12}>
                      <Card style={{ marginTop: '0px' }}>
                        <CardHeader icon>
                          <CardIcon color={props.themeContext.buttonColor}>
                            <Map />
                          </CardIcon>
                          <h4 className={classes.cardIconTitle}>Rutas por recorrer</h4>
                        </CardHeader>
                        <CardBody>
                          <List
                            component="nav"
                            aria-label="Listado de rutas"
                            className={classes.listRoutes}
                          >
                            {dataGeneral.routes.map((route, i) => {
                              return (
                                <ListItem
                                  button
                                  key={i}
                                  onClick={() => {
                                    setShowModaRouteEdit(true);
                                    setRouteId(route.id);
                                  }}
                                  className={classes.listItemData}
                                >
                                  <ListItemIcon style={{ color: '#00c369' }}>
                                    <MapIcon />
                                  </ListItemIcon>
                                  <div
                                    style={{
                                      fontSize: '15px',
                                      display: 'flex',
                                      alignItems: 'center',
                                    }}
                                  >
                                    <span>{route.description}</span>
                                  </div>
                                  <div className={classes.addressData}>
                                    <Tooltip title="Clientes">
                                      <span style={{ color: '#007eff' }}>
                                        <Room />
                                        {route.addressData.total_addresses}
                                      </span>
                                    </Tooltip>
                                    <Tooltip title="LatLng Válidos">
                                      <span style={{ color: '#00c369' }}>
                                        <Room />
                                        {route.addressData.correct_addresses}
                                      </span>
                                    </Tooltip>
                                    <Tooltip title="LatLng inválidos">
                                      <span style={{ color: '#ff0052' }}>
                                        <LocationOff />
                                        {route.addressData.incorrect_addresses}
                                      </span>
                                    </Tooltip>
                                  </div>
                                </ListItem>
                              );
                            })}
                          </List>
                        </CardBody>
                      </Card>
                    </GridItem>
                  </GridContainer>

                  <Card className={classes.card}>
                    <CardHeader icon>
                      <CardIcon color={props.themeContext.buttonColor}>
                        <Map />
                      </CardIcon>
                      <h4
                        className={classes.cardIconTitle}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          flexDirection: window.screen.width > 1024 ? 'row' : 'column',
                        }}
                      >
                        <span>
                          Historial del día<span style={{ fontSize: '12px' }}>: {date}</span>
                        </span>
                        <span style={{ fontSize: '10px' }}>{maxDistance}m distancia válida</span>
                        <span style={{ fontSize: '14px', color: '#ff002f' }}>
                          {dataGps.notGps} Puntos sin gps
                        </span>
                      </h4>
                    </CardHeader>
                    <CardBody>
                      <List
                        component="nav"
                        aria-label="Listado de órdenes"
                        className={classes.listHistory}
                      >
                        {/* // Listado de ordenes */}
                        {showMarker.order && !showMarker.notOrder
                          ? dataGeneral.orders.map((item, i) => {
                              return (
                                <ListItem
                                  button
                                  key={item.id}
                                  selected={
                                    !!dataOrder
                                      ? dataOrder.id == item.id
                                        ? true
                                        : false
                                      : undefined
                                  }
                                  className={classes.listItemData}
                                  style={{
                                    backgroundColor:
                                      // Distancia maxima
                                      item.distance !== null && item.distance > maxDistance
                                        ? '#ffa50045'
                                        : undefined,
                                  }}
                                >
                                  <ListItemIcon
                                    onClick={() => setDataOrder({ ...item, _state: true })}
                                    style={{ minWidth: 'auto' }}
                                  >
                                    <span>
                                      <img src="/img/order.png"></img>
                                    </span>
                                  </ListItemIcon>
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      minWidth: '80px',
                                      display: 'flex',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    {!item.distance ? '-' : `${item.distance} m`}
                                  </span>
                                  <ListItemIcon
                                    onClick={() =>
                                      setDataOrder({
                                        ...item,
                                        latitude: item.address.latitude,
                                        longitude: item.address.longitude,
                                        _state: true,
                                      })
                                    }
                                  >
                                    <span>
                                      <img src="/img/GoogleMarker.png"></img>
                                    </span>
                                  </ListItemIcon>
                                  <ListItemIcon
                                    onClick={() => {
                                      window.open(
                                        `/admin/ventas/operaciones/pedidos${item.state === undefined ? '/' :
                                          item.state === 'R' ? '-retenidos/' : '-comprometidos/'
                                        }${item.id}`,
                                        '_blank',
                                      );
                                    }}
                                  >
                                    <Button
                                      justIcon
                                      round
                                      simple
                                      color={'primary'}
                                      onClick={() => {
                                        window.open(
                                          `/admin/ventas/operaciones/pedidos${item.state === undefined ? '/' :
                                            item.state === 'R' ? '-retenidos/' : '-comprometidos/'
                                          }${item.id}`,
                                          '_blank',
                                        );
                                      }}
                                    >
                                      <Visibility />
                                    </Button>
                                  </ListItemIcon>
                                  <span style={{ fontSize: '15px' }}>{i + 1 + ' ->'}</span>
                                  <span style={{ marginLeft: '20px' }}>{item.CardName}</span>
                                  <span style={{ marginLeft: '20px' }}>
                                    {currency(item.total_amount)}
                                  </span>
                                  <span style={{ marginLeft: '20px' }}>
                                    {stateOrder(item.state)}
                                  </span>
                                  <span
                                    style={{
                                      right: 0,
                                      position: 'absolute',
                                      marginRight: '10px',
                                    }}
                                  >
                                    {moment(item.created_at).format('HH:mm:ss')}
                                  </span>
                                </ListItem>
                              );
                            })
                          : undefined}

                        {/* // Listado de no ordenes */}
                        {showMarker.notOrder && !showMarker.order
                          ? dataGeneral.notOrders.map((item, i) => {
                              return (
                                <ListItem
                                  button
                                  key={item.id}
                                  selected={
                                    !!dataNotOrder
                                      ? dataNotOrder.id == item.id
                                        ? true
                                        : false
                                      : undefined
                                  }
                                  className={classes.listItemData}
                                  style={{
                                    backgroundColor:
                                      // Distancia maxima
                                      item.distance !== null && item.distance > maxDistance
                                        ? '#ffa50045'
                                        : undefined,
                                  }}
                                >
                                  <ListItemIcon
                                    onClick={() => setDataNotOrder({ ...item, _state: true })}
                                    style={{ minWidth: 'auto' }}
                                  >
                                    <img src="/img/notOrder.png"></img>
                                  </ListItemIcon>
                                  <span
                                    style={{
                                      fontSize: '15px',
                                      minWidth: '80px',
                                      display: 'flex',
                                      justifyContent: 'center',
                                    }}
                                  >
                                    {!item.distance ? '-' : `${item.distance} m`}
                                  </span>
                                  <ListItemIcon
                                    onClick={() =>
                                      setDataNotOrder({
                                        ...item,
                                        latitude: item.address.latitude,
                                        longitude: item.address.longitude,
                                        _state: true,
                                      })
                                    }
                                  >
                                    <img src="/img/GoogleMarker.png"></img>
                                  </ListItemIcon>
                                  <span style={{ fontSize: '15px' }}>{i + 1 + ' ->'}</span>
                                  <span style={{ marginLeft: '20px' }}>{item.CardName}</span>
                                  <span style={{ marginLeft: '20px' }}>
                                    {'-> ' + item.reason_description}
                                  </span>
                                  <span
                                    style={{
                                      right: 0,
                                      position: 'absolute',
                                      marginRight: '10px',
                                    }}
                                  >
                                    {moment(item.created_at).format('HH:mm:ss')}
                                  </span>
                                </ListItem>
                              );
                            })
                          : undefined}

                        {/* // Listado de puntos gps */}
                        {!showMarker.order && !showMarker.notOrder
                          ? dataGps.gps.map((item, i) => {
                              return (
                                <ListItem
                                  button
                                  onClick={() => {
                                    setPointSeleted({
                                      lat: parseFloat(item.latitude),
                                      lng: parseFloat(item.longitude),
                                    });
                                    setDataPoint({ _state: false });
                                  }}
                                  key={item.id}
                                  selected={
                                    !!pointSelected
                                      ? pointSelected.lat == parseFloat(item.latitude) &&
                                        pointSelected.lng == parseFloat(item.longitude)
                                        ? true
                                        : false
                                      : undefined
                                  }
                                  className={classes.listItemData}
                                >
                                  <ListItemIcon style={{ color: '#00c369' }}>
                                    <Room />
                                  </ListItemIcon>
                                  <span style={{ fontSize: '15px' }}>
                                    {'Punto ' + (i + 1) + ' ->'}
                                  </span>
                                  <span style={{ marginLeft: '20px' }}>
                                    {moment(item.created_at).format('H:mm:ss')}
                                  </span>
                                </ListItem>
                              );
                            })
                          : undefined}

                        {/* // Listado de todos los pedidos y no pedidos */}
                        {showMarker.order && showMarker.notOrder
                          ? dataGeneral.allOrders.map((item, i) => {
                              if (item.base_reason_id_not_order === null) {
                                return (
                                  <ListItem
                                    button
                                    key={item.id}
                                    selected={
                                      !!dataOrder
                                        ? dataOrder.id == item.id
                                          ? true
                                          : false
                                        : undefined
                                    }
                                    className={classes.listItemData}
                                    style={{
                                      backgroundColor:
                                        // Distancia maxima
                                        item.distance !== null && item.distance > maxDistance
                                          ? '#ffa50045'
                                          : undefined,
                                    }}
                                  >
                                    <ListItemIcon
                                      onClick={() => setDataOrder({ ...item, _state: true })}
                                      style={{ minWidth: 'auto' }}
                                    >
                                      <span>
                                        <img src="/img/order.png"></img>
                                      </span>
                                    </ListItemIcon>
                                    <span
                                      style={{
                                        fontSize: '15px',
                                        minWidth: '80px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      {!item.distance ? '-' : `${item.distance} m`}
                                    </span>
                                    <ListItemIcon
                                      onClick={() =>
                                        setDataOrder({
                                          ...item,
                                          latitude: item.address.latitude,
                                          longitude: item.address.longitude,
                                          _state: true,
                                        })
                                      }
                                    >
                                      <span>
                                        <img src="/img/GoogleMarker.png"></img>
                                      </span>
                                    </ListItemIcon>
                                    <ListItemIcon>
                                      <span>
                                        <Button
                                          justIcon
                                          round
                                          simple
                                          color={'primary'}
                                          onClick={() => {
                                            window.open(
                                              `/admin/ventas/operaciones/pedidos${
                                                item.state === 'R' || item.state === 'X'
                                                  ? '-comprometidos/'
                                                  : '/'
                                              }${
                                                item.state === 'R' || item.state === 'X'
                                                  ? item.id
                                                  : item.sale_order_id
                                              }`,
                                              '_blank',
                                            );
                                          }}
                                        >
                                          <Visibility />
                                        </Button>
                                      </span>
                                    </ListItemIcon>
                                    <span style={{ fontSize: '15px' }}>{i + 1 + ' ->'}</span>
                                    <span style={{ marginLeft: '20px' }}>{item.CardName}</span>
                                    <span style={{ marginLeft: '20px' }}>
                                      {currency(item.total_amount)}
                                    </span>
                                    <span style={{ marginLeft: '20px' }}>
                                      {stateOrder(item.state)}
                                    </span>
                                    <span
                                      style={{
                                        right: 0,
                                        position: 'absolute',
                                        marginRight: '10px',
                                      }}
                                    >
                                      {item.created_at}
                                    </span>
                                  </ListItem>
                                );
                              } else {
                                return (
                                  <ListItem
                                    button
                                    key={item.id}
                                    selected={
                                      !!dataNotOrder
                                        ? dataNotOrder.id == item.id
                                          ? true
                                          : false
                                        : undefined
                                    }
                                    className={classes.listItemData}
                                    style={{
                                      backgroundColor:
                                        // Distancia maxima
                                        item.distance !== null && item.distance > maxDistance
                                          ? '#ffa50045'
                                          : undefined,
                                    }}
                                  >
                                    <ListItemIcon
                                      onClick={() => setDataNotOrder({ ...item, _state: true })}
                                      style={{ minWidth: 'auto' }}
                                    >
                                      <img src="/img/notOrder.png"></img>
                                    </ListItemIcon>
                                    <span
                                      style={{
                                        fontSize: '15px',
                                        minWidth: '80px',
                                        display: 'flex',
                                        justifyContent: 'center',
                                      }}
                                    >
                                      {!item.distance ? '-' : `${item.distance} m`}
                                    </span>
                                    <ListItemIcon
                                      onClick={() =>
                                        setDataNotOrder({
                                          ...item,
                                          latitude: item.address.latitude,
                                          longitude: item.address.longitude,
                                          _state: true,
                                        })
                                      }
                                    >
                                      <img src="/img/GoogleMarker.png"></img>
                                    </ListItemIcon>
                                    <span style={{ fontSize: '15px' }}>{i + 1 + ' ->'}</span>
                                    <span style={{ marginLeft: '20px' }}>{item.CardName}</span>
                                    <span style={{ marginLeft: '20px' }}>
                                      {'-> ' + item.reason_description}
                                    </span>
                                    <span
                                      style={{
                                        right: 0,
                                        position: 'absolute',
                                        marginRight: '10px',
                                      }}
                                    >
                                      {item.created_at}
                                    </span>
                                  </ListItem>
                                );
                              }
                            })
                          : undefined}
                      </List>
                    </CardBody>
                  </Card>
                </GridItem>
              </GridContainer>
            </GridItem>
          </GridContainer>
        ) : undefined}
      </Dialog>
    </Fragment>
  );
});

const QuotaSellerData = ({
  classes,
  pendingAmt,
  quotaData,
  orders,
  notOrders,
  customerVisited,
  dataList,
}) => {
  return (
    <Table className={classes.table} aria-label="seller table">
      <TableHead>
        <TableRow>
          <TableCell>Cuota</TableCell>
          <TableCell>Cuota Sin Igv</TableCell>
          <TableCell>Procesados</TableCell>
          <TableCell>Procesados Sin Igv</TableCell>
          <TableCell>Pendientes</TableCell>
          <TableCell>% Avance</TableCell>
          <TableCell>T. Clientes</TableCell>
          <TableCell>Pedidos</TableCell>
          <TableCell>No pedidos</TableCell>
          <TableCell>% Efectividad</TableCell>
          <TableCell>Visitados</TableCell>
          <TableCell>% Visitados</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableCell>{!!quotaData.quota_igv ? parseFloat(quotaData.quota_igv).toFixed(2) : 0}</TableCell>
          <TableCell>{!!quotaData.quota ? parseFloat(quotaData.quota).toFixed(2) : 0}</TableCell>
          <TableCell>{!!quotaData.progress_igv ? parseFloat(quotaData.progress_igv).toFixed(2) : 0}</TableCell>
          <TableCell>{!!quotaData.progress ? parseFloat(quotaData.progress).toFixed(2) : 0}</TableCell>
          <TableCell>{currency(pendingAmt)}</TableCell>
          {/* % Avance */}
          <TableCell>
            <span style={{ color: quotaData.progress_percentage_igv > 100 ? '#1ebf50' : 'initial' }}>{quotaData.progress_percentage_igv}%</span>
          </TableCell>
          {/* T. Clientes */}
          <TableCell>{dataList.total_customers}</TableCell>
          <TableCell>{orders.length}</TableCell>
          <TableCell>{notOrders.length}</TableCell>
          {/* Efectividad */}
          <TableCell>
            {dataList.total_customers < 1
              ? 0
              : (
                  ([...new Set(orders.map((order) => order.base_address_id))].length * 100) /
                    dataList.total_customers || 0
                ).toFixed(2)}
            %
          </TableCell>
          {/* Visitados */}
          <TableCell>{customerVisited}</TableCell>
          {/* % Visitados */}
          <TableCell>
            {dataList.total_customers < 1
              ? 0
              : ((customerVisited * 100) / dataList.total_customers || 0).toFixed(2)}
            %
          </TableCell>
        </TableRow>
      </TableBody>
    </Table>
  );
};

const QuotaMarkData = ({ classes, quotaMark }) => (
  <Table className={classes.table} aria-label="mark table">
    <TableHead>
      <TableRow>
        <TableCell>Cuota</TableCell>
        <TableCell>Venta</TableCell>
        <TableCell>% Avance</TableCell>
        <TableCell>T. Clientes</TableCell>
        <TableCell>Pedidos</TableCell>
        <TableCell>% Efectividad</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <TableRow>
        <TableCell>{currency(quotaMark?.quota)}</TableCell>
        <TableCell>{currency(quotaMark?.progress_amount)}</TableCell>
        <TableCell>
          <span
            style={{
              color: quotaMark?.progress_percentage > 100 ? '#45c51b' : 'initial',
            }}
          >
            {nPercent(quotaMark?.progress_percentage)}
          </span>
        </TableCell>
        <TableCell>{quotaMark?.total_clients || 0}</TableCell>
        <TableCell>{quotaMark?.orders || 0}</TableCell>
        <TableCell>
          {quotaMark?.total_clients > 0
            ? nPercent((quotaMark?.orders * 100) / quotaMark?.total_clients)
            : 0}
        </TableCell>
      </TableRow>
    </TableBody>
  </Table>
);

const ShowOptions = ({ handleShowMarker, nameList, total }) => {
  const [selecteds, setSelecteds] = useState(() => ['order']);
  return (
    <ToggleButtonGroup
      value={selecteds}
      onChange={(e, val) => setSelecteds(val)}
      aria-label="marcadores"
    >
      <ToggleButton value="order" aria-label="pedidos" color="success" onClick={handleShowMarker}>
        <ShoppingCartRounded />
        {total.orders}
      </ToggleButton>

      {nameList === 'seller' ? (
        <ToggleButton
          value="notOrder"
          aria-label="no pedidos"
          color="error"
          onClick={handleShowMarker}
        >
          <RemoveShoppingCartRounded />
          {total.notOrders}
        </ToggleButton>
      ) : undefined}

      <ToggleButton
        value="route"
        aria-label="seguimiento en ruta"
        color="info"
        onClick={handleShowMarker}
      >
        <PersonPinCircle />
      </ToggleButton>
      <ToggleButton
        value="allMarkers"
        aria-label="todos los puntos"
        color="secondary"
        onClick={handleShowMarker}
      >
        <GpsFixed />
      </ToggleButton>
    </ToggleButtonGroup>
  );
};

const Legend = ({ classes, showAddresses, setShowAddresses }) => (
  <GridItem xs={12} sm={12} md={12}>
    <div className={classes.legend}>
      <div className={classes.contLegend}>
        <Avatar src="/img/pingIco.png" variant="square" className={classes.avatar} />
        <span>Inicio recorrido</span>
      </div>
      <div className={classes.contLegend}>
        <Avatar src="/img/point.png" variant="square" className={classes.avatar} />
        <span>Puntos recorridos</span>
      </div>
      <div className={classes.contLegend}>
        <Avatar src="/img/mark.png" variant="square" className={classes.avatar} />
        <span>Guía / Indicador</span>
      </div>
      <div className={classes.contLegend}>
        <Avatar src="/img/order.png" variant="square" className={classes.avatar} />
        <span>Órdenes</span>
      </div>
      <div className={classes.contLegend} style={{ flexDirection: 'column' }}>
        <div style={{ display: 'flex' }}>
          <Avatar src="/img/marcadores/amarillo.png" variant="square" className={classes.avatar} />
          <span>Dirección</span>
        </div>
        <Checkbox margin="normal" checked={showAddresses} onChange={_ => setShowAddresses(show => !show)} />
      </div>
      <div className={classes.contLegend}>
        <Avatar src="/img/notOrder.png" variant="square" className={classes.avatar} />
        <span>No órdenes</span>
      </div>
      <div className={classes.contLegend}>
        <Avatar alt="Remy Sharp" src="/img/plas.png" variant="square" className={classes.avatar} />
        <span>Puntos infiltrado</span>
      </div>
      <div className={classes.contLegend}>
        <Avatar
          alt="Remy Sharp"
          src="/img/pingEndIco.png"
          variant="square"
          className={classes.avatar}
        />
        <span>Fin recorrido</span>
      </div>
    </div>
  </GridItem>
);
